import { AddPendidikanPayload } from "../../../../models/Pendidikan";
import { getApiInstance } from "../../../api";
import mutationWrapper from "../../mutationWrapper";
import { allPendidikanKey } from "../../queries/Pendidikan/useFetchAllPendidikan";
import getQueryClient from "../../queryClient";
import ApiClient from "../../../apiClient";

export async function addPendidikan(data: AddPendidikanPayload) {
  const res = await ApiClient.post(`/AddPendidikanSelection`, data);
  return res.data;
}

export const useAddPendidikan = mutationWrapper(addPendidikan, {
  onSuccess: () => {
    getQueryClient().invalidateQueries(allPendidikanKey);
  },
});
